import axios from 'axios';

export function bootstrapProxyReadonly({ role, idToken, authId, proxyUserId }) {
  return axios
    .get(`${process.env.VUE_APP_COMPANY_SITE_URL}/projects`, {
      headers: {
        Authorization: 'Bearer ' + idToken,
        'x-api-key': process.env.VUE_APP_X_API_KEY
      },
      params: {
        auth_id: authId,
        r: role,
        proxyUserId: proxyUserId
      }
    })
    .then(response => ({
      projects: response.data.projects || [],
      effectiveSub: response.data.effectiveSub,
      userId: response.data.userId
    }));
}
